(() => {
  const initRelatedCarousel = (carousel) => {
    if (!carousel || carousel.dataset.relatedCarouselBound === 'true') return;
    carousel.dataset.relatedCarouselBound = 'true';

    const track = carousel.querySelector('[data-related-track]');
    const prevButton = carousel.querySelector('[data-related-prev]');
    const nextButton = carousel.querySelector('[data-related-next]');
    if (!track || !prevButton || !nextButton) return;

    const getScrollStep = () => Math.max(track.clientWidth * 0.85, 1);

    const updateButtons = () => {
      const maxScrollLeft = Math.max(track.scrollWidth - track.clientWidth, 0);
      const currentScrollLeft = Math.max(track.scrollLeft, 0);
      const tolerance = 2;

      prevButton.disabled = currentScrollLeft <= tolerance;
      nextButton.disabled = currentScrollLeft >= maxScrollLeft - tolerance;
      carousel.classList.toggle('is-scrollable', maxScrollLeft > tolerance);
    };

    const scrollTrack = (direction) => {
      track.scrollBy({
        left: getScrollStep() * direction,
        behavior: 'smooth',
      });
    };

    prevButton.addEventListener('click', () => scrollTrack(-1));
    nextButton.addEventListener('click', () => scrollTrack(1));
    track.addEventListener('scroll', updateButtons, { passive: true });
    window.addEventListener('resize', updateButtons);
    updateButtons();
  };

  const init = () => {
    document.querySelectorAll('[data-diy-related-carousel]').forEach(initRelatedCarousel);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init, { once: true });
  } else {
    init();
  }
})();
